import {
  useMutation, useQueryClient 
} from '@tanstack/react-query';
import { startReceiving } from '../api/receiving-client';

export function useStartReceiving() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (deliveryId: string) => startReceiving(deliveryId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['deliveries'] });
    },
  });
}
